export default __webpack_public_path__ + "static/media/defaultcard.7cfde55e.svg";